var map = {
	"./6+ months project.md": 9852,
	"./Algorithms.md": 1881,
	"./Certificates.md": 5168,
	"./How to design a function.md": 3603,
	"./How to manage your dependencies.md": 2233,
	"./Proof of work - Cybersecurity.md": 6551,
	"./Write code, not comments.md": 2882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8802;